// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from "./router";
import store from "./store";
import App from "./app.vue";
import iView from 'iview';
import axios from "axios";
import 'iview/dist/styles/iview.css';
import VueLazyload from 'vue-lazyload';

//样式部分
import "@/assets/css/bootstrap.min.css";
import "@/assets/css/font-awesome.min.css";
import "@/assets/css/owl.carousel.css";
import "@/assets/css/owl.theme.default.min.css";
import "@/assets/css/hover.css";
import "@/assets/css/jquery.fancybox.css";
import "@/assets/css/jquery.bxslider.css";
import "@/assets/css/animate.min.css";
import "@/assets/fonts/flaticon/flaticon.css";
import "@/assets/revolution/css/settings.css";
import "@/assets/js/jquery-ui-1.11.4/jquery-ui.css";
import "@/assets/css/style.css";
import "@/assets/css/bootstrap-margin-padding.css";
import "@/assets/css/responsive.css";

Vue.use(iView);
Vue.use(VueLazyload);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './static/default.png',
  loading: './static/default.png',
  attempt: 1
})

/**
 * axios默认配置
 */
// axios.defaults.baseURL = 'https://bx.dev.c-cf.cn/rest';
axios.defaults.baseURL = 'http://api.bxgkzy.com/rest';
axios.defaults.timeout = 5000;

/**
 * axios拦截器
 */
 // 添加请求拦截器
axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

 // 添加响应拦截器
axios.interceptors.response.use(function (response) {
    return response.data; //直接返回后端数据
}, function (error) {
    return Promise.reject(error);
});

Vue.prototype.$http = axios;

//路由跳转前的显示loading
router.beforeEach((to,from,next)=>{
    $('.preloader').show();
    next();
});
//路由跳转自动回顶部
router.afterEach(()=>{
    let isBottom = localStorage.getItem('isBottom'),top = 0;
    // console.log(!!isBottom);
    if(isBottom){
        top = $(document).height()-$(window).height();
        localStorage.removeItem('isBottom');
    }
    $("html,body").animate({
        scrollTop: top
    },1);
    $('.preloader').delay(500).fadeOut(500);
});

Vue.config.productionTip = false;

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js